export function getVehicleRfIndicators(device) {
    const { rf_status } = device;
    const shared_rf_indicators = Object.entries(rf_status || {}).map(([id, spec]) => {
        const { name, slot, serial, time, rf_label } = spec;
        const radio_mark_enabled = rf_label === true;
        return {
            id: Number(id),
            name: name ? name.toString() : '',
            slot,
            serial,
            time,
            radio_mark_enabled,
        };
    });
    return shared_rf_indicators;
}
